import { mdiChevronLeft, mdiRefresh } from '@mdi/js'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        refresh: mdiRefresh
      }
    }
  },

  computed: {
    ...mapState({
      stop: state => state.stop.stopDetails,
      landmarks: state => state.options.landmarks,
      stores: state => state.options.stores,
      restaurants: state => state.options.restaurants,
      fetchingLandmarks: state => state.options.fetching_landmarks,
      fetchingStores: state => state.options.fetching_stores,
      fetchingRestaurants: state => state.options.fetching_restaurants
    })
  },

  methods: {
    ...mapActions({
      getLandmarks: 'options/getLandmarks',
      getStores: 'options/getStores',
      getRestaurants: 'options/getRestaurants'
    })
  }
}
